export default __webpack_public_path__ + "static/media/productHealthCheckPackage1_male_Hk.3211bd6b.webp";